var WorkAutoStatusModal = (function (base) {
  __extends(WorkAutoStatusModal, base);


  function WorkAutoStatusModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };


  WorkAutoStatusModal.prototype.activate = function (workId, statusName) {
    const self = this;
    const url = 'api/works/{0}/update/status'.format(workId);

    this.loadContent(url, { statusName: statusName || 'Назначена' })
      .then($modal => {
        var $form = $('form', $modal);
        FormHelper.init($form, 'POST', 'api/works/{0}/update/status'.format(workId));

        $modal

          //Кнопка 'Ок' для автообновления статуса
          .on('click', '[js=update]', function () {
            $modal.busy();
            $form.send()
              .then(() => {
                self.close({ ok: true, id: workId });
                WorkViewModal.prototype.constructor.reloadContent('api/works/{0}'.format(workId))
              })
              .catch(() => { $modal.busy(false); });
          })
      });
  };

  return WorkAutoStatusModal;
}(BaseModal));
